<template>
  <div class="clearfix">
    <p class="title">
      <img
        class="icon"
        :src="group.title | toIcon"
      >
      <span class="text">
        {{ group.title }}
      </span>
    </p>
    <div class="content">
      <NavItem
        v-for="item in group.items"
        :key="item.name"
        class="item"
        :item="item"
      />
    </div>
  </div>
</template>

<script>
import NavItem from '@/components/Navigation/Item.vue';
import privateIcon from '@/assets/home/private_icon.png';
import publicIcon from '@/assets/home/public_icon.png';
import qrIcon from '@/assets/home/qr_icon.png';

export default {
  components: { NavItem },
  props: {
    group: {
      type: Object,
      default: () => { },
    },
  },
  filters: {
    toIcon: (name) => {
      if (name === '公共应用') {
        return privateIcon;
      }
      if (name === '私有应用') {
        return publicIcon;
      }
      return qrIcon;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.title {
  float: left;
  padding: 30px 0;
  width: 120px;
  color: $info;
  line-height: 20px;
  text-align: left;
  .icon {
    width: 24px;
    height: 24px;
    vertical-align: middle;
  }
  .text {
    vertical-align: middle;
  }
}
.content {
  display: inline-block;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  .item {
    padding: 30px 15px;
    position: relative;
  }
}
</style>
